import type { I18n } from '@lingui/core'

import { EXPERIMENT_VARIATION } from 'shared/experiments/consts'

export const getPlaceholderTextForExperiment = (
  variant: EXPERIMENT_VARIATION,
  defaultPlaceHolderText: string,
  i18n: I18n
) => {
  switch (variant) {
    case EXPERIMENT_VARIATION.DEFAULT:
      return defaultPlaceHolderText
    case EXPERIMENT_VARIATION.V1:
      return i18n._('general.label.placeholder.searchForProduct')
    case EXPERIMENT_VARIATION.V2:
      return i18n._('general.label.placeholder.searchNow')
    case EXPERIMENT_VARIATION.V3:
      return i18n._('general.label.placeholder.searchYourProduct')
    case EXPERIMENT_VARIATION.V4:
      return i18n._('general.label.placeholder.searchFor')
    case EXPERIMENT_VARIATION.V5:
      return i18n._('general.label.placeholder.searchOnSAE')
    default:
      return defaultPlaceHolderText
  }
}
